<script lang="ts">
</script>

<svg
  width="20"
  height="14"
  viewBox="0 0 14 10"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g filter="url(#filter0_d_14016_10765)">
    <path
      d="M6.4453 1.6302L4 0H10L7.5547 1.6302C7.2188 1.85413 6.7812 1.85413 6.4453 1.6302Z"
      style="fill: #1D2532 !important;"
    />
    <path
      d="M9.00977 0.299805L7.38867 1.38086C7.18293 1.51802 6.92249 1.53451 6.70312 1.43164L6.61133 1.38086L4.99023 0.299805H9.00977Z"
      style="stroke: #1D2532 !important;"
      stroke-width="0.6"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </g>
  <defs>
    <filter
      id="filter0_d_14016_10765"
      x="0"
      y="0"
      width="14"
      height="9.79785"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feColorMatrix
        in="SourceAlpha"
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        result="hardAlpha"
      />
      <feOffset dy="4" />
      <feGaussianBlur stdDeviation="2" />
      <feComposite in2="hardAlpha" operator="out" />
      <feColorMatrix
        type="matrix"
        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
      />
      <feBlend
        mode="normal"
        in2="BackgroundImageFix"
        result="effect1_dropShadow_14016_10765"
      />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="effect1_dropShadow_14016_10765"
        result="shape"
      />
    </filter>
  </defs>
</svg>
